<template>
  <span v-if="show" class="trend-badge" :class="pct >= 0 ? 'up' : 'down'">
    {{ pct >= 0 ? "▲ +" : "▼ " }}{{ Math.abs(pct).toFixed(1) }}%<template v-if="label"> {{ label }}</template>
  </span>
</template>

<script>
export default {
  name: "TrendBadge",
  props: { pct: { type: Number, default: null }, label: { type: String, default: "" } },
  computed: {
    // pct can arrive as Infinity (vs zero baseline) or NaN (0/0) from API math
    show() { return Number.isFinite(this.pct); },
  },
};
</script>

<style scoped>
.trend-badge { display: inline-flex; padding: 1px 7px; border-radius: 999px; font-size: 11px; font-weight: 700; white-space: nowrap; }
.trend-badge.up { background: #22c55e15; color: #22c55e; }
.trend-badge.down { background: #ef444415; color: #ef4444; }
</style>
